// client/src/components/StudentsImportModal.jsx
// Students-specific configuration of the generic ImportWizard. Supplies the
// column spec (for the format guide) + the analyze/commit handlers; all the
// flow, column report and summary UI lives in ImportWizard so other
// resources can reuse it.

import ImportWizard from './ImportWizard.jsx';
import { useStudentImport } from '../hooks/useStudents.js';

// Display spec — must mirror STUDENT_IMPORT_SPEC labels in the service.
const STUDENT_COLUMNS = [
  { label: 'שם פרטי', required: true },
  { label: 'שם משפחה', required: true },
  { label: 'מספר זהות' },
  { label: 'כיתה', note: 'תיווצר אוטומטית אם לא קיימת' },
  { label: 'מזהה חיצוני' },
  { label: 'מספר כרטיס' },
  { label: 'הערות' },
  { label: 'מזהה מערכת', note: 'לעדכון תלמיד קיים' },
];

export default function StudentsImportModal({ open, onClose, campId }) {
  const { analyze, commit } = useStudentImport(campId);
  return (
    <ImportWizard
      open={open}
      onClose={onClose}
      title="ייבוא תלמידים מאקסל"
      entityName="תלמידים"
      spec={STUDENT_COLUMNS}
      analyze={analyze}
      commit={commit}
    />
  );
}
